// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__sRUDr","footer__logo":"styles_footer__logo__OzI4S","footer__menu":"styles_footer__menu__vNPRt","footer__soc":"styles_footer__soc__qL9mm"};